<script>
    export let project;
    import ProjectDisplayButton from "./project_display_button.svelte";
    import ProjectDisplaySkill from "./project_display_skill.svelte";
</script>

<div id="card">
    <img id="image" src={project.images[0]} alt=" ">
    <div id="card-text-div">
        <p class="primary max-lines">{project.title}</p>
        <p class='secondary'>{project.type}</p>
        <div class="row">
            {#each project.skills as skill}
                <ProjectDisplaySkill {skill} />
            {/each}
        </div>
        <div id="body-div">
        <p class="max-lines" id="body-text">{project.description}</p>
        </div>
        <div class="button-row">
            {#each project.buttons as button}
                <ProjectDisplayButton {button} />
            {/each}
        </div>
    </div>
</div>

<style>
    #card {
        background-color: rgba(39, 255, 230, 0.4);
        width: 600px;
        max-height: 100%;
        flex-direction: row;
        display: flex;
        padding-left: 24px;
        padding-right: 24px;
        padding-top: 24px;
        padding-bottom: 24px;
        margin-right: 48px;
        border-radius: 16px;
        align-items: center;
        border: 5px solid rgba(0, 0, 0, 0.9);
    }
    #card-text-div {
        width: 300px;
        flex-direction: column;
        display: flex;
        border-radius: 8px;
        margin-top: 24px;
        padding-right: 24px;
    }
    #image {
        width: 250px;
        margin-left: 0px;
        margin-right: 24px;
        margin-bottom: 12px;
    }
    .primary {
        font-weight: bold;
        color: rgba(12, 40, 20, 1);
        margin: 0;
        font-size: 32px;
        line-height: 1.2em !important;
    }
    .secondary {
        font-weight: bold;
        color: rgba(24, 100, 100, 1);
        font-size: 16px;
        line-height: 14px;
    }
    #body-text {
        color: rgba(12, 80, 50, 0.9);
        font-size: 16px;
    }
    #body-div {
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .max-lines {
        white-space: initial;
        width: 300px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 10;
        line-height: 1.5em;
    }
    .row {
        display: inline-flex;
        max-width: 300px;
        flex-wrap: wrap;
        flex-direction: row;
    }
    .button-row {
        display: inline;
        max-width: 300px;
        flex-wrap: wrap;
    }

    @media (max-width: 952px) {
        #card {
            width: calc(100vw - 48px - 5px*2 - 24px);
            scale: 1;
            margin-right: 0px;
            flex-direction: column;
            display: flex;
            align-items: center;
            border: 4px solid rgba(0, 0, 0, 0.9);
            margin-bottom: 24px;
            background-color: rgba(39, 255, 230, 0.5);
        }
        #card-text-div {
            width: calc(100vw - 48px - 5px*2 - 48px);
            flex-direction: column;
            display: flex;
            border-radius: 8px;
            margin-top: 24px;
            padding-right: 24px;
        }
    }

</style>